export interface SpendXGetYMetadata {
  applicableProducts?: number[];
  applicableCategories?: number[];
  spendLimit: number;
  globalSpendLimit: number;
  promotionProducts?: number[];
  promotionCategories?: number[];
}

export const getEmptySpendXGetYMetadata = (): SpendXGetYMetadata => ({
  spendLimit: 0,
  globalSpendLimit: 0,
});

export const spendXGetYMetadataFromResponse = (
  responseData: any,
): SpendXGetYMetadata => ({
  applicableProducts: responseData.applicable_products,
  applicableCategories: responseData.applicable_categories,
  spendLimit: responseData.spend_limit,
  globalSpendLimit: responseData.global_spend_limit,
  promotionProducts: responseData.promotion_products,
  promotionCategories: responseData.promotion_categories,
});

export const spendXGetYMetadataToUpsertRequest = (
  metadata: SpendXGetYMetadata,
) => ({
  applicable_products: metadata.applicableProducts,
  applicable_categories: metadata.applicableCategories,
  spend_limit: metadata.spendLimit,
  global_spend_limit: metadata.globalSpendLimit,
  promotion_products: metadata.promotionProducts,
  promotion_categories: metadata.promotionCategories,
});
